import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { calculateDemandCountryColors } from '@/features/demand/calculateDemandCountryColors'
import { tableColumns } from '@/features/demand/columns'
import { exportFields } from '@/features/demand/exportFields'
import {
	createInitialDemandFilterGroups,
	demandMapDeploymentsQueryOptions,
} from '@/features/demand/initialiseDemandData'
import type { DemandMapDeployment } from '@/features/demand/models/demandSchema'
import FilteredMap from '@/features/filteredMap/index'

export const Route = createFileRoute('/demand')({
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(demandMapDeploymentsQueryOptions),
	component: RouteComponent,
	head: () => ({
		meta: [
			{
				title: 'Demand',
			},
		],
	}),
})

declare module 'react' {
	interface CSSProperties {
		'--grid-template-columns-details-grid'?: string
	}
}
function RouteComponent() {
	const { isLoading, data } = useSuspenseQuery(
		demandMapDeploymentsQueryOptions
	)
	const { filterGroups, initialData } = createInitialDemandFilterGroups(
		data.deployments
	)

	if (isLoading) return <div>Loading...</div>
	return (
		<div
			className=""
			style={{
				'--grid-template-columns-details-grid':
					'minmax(0, 1fr) repeat(4, minmax(0, 0.6fr))  minmax(0, 0.8fr)',
			}}
		>
			<FilteredMap<DemandMapDeployment>
				filterGroups={filterGroups}
				initialData={initialData}
				themeColor="cyan"
				mapTitle="Enterprise Demand"
				calculateCountriesColorMappingFn={calculateDemandCountryColors}
				tableColumns={tableColumns}
				exportFields={exportFields}
				drawerTitle="Enterprise Demand"
			/>
		</div>
	)
}
